import React, { Component } from 'react';
import { Box, Button, Card, Grid, Typography, TableHead, TableBody, TableRow, TableCell, IconButton, Fab } from '@material-ui/core';
import axios from 'axios';
import PopUp from '../../../../commonModules/interface/PopUp';
import { TableLayout } from '../containers/Layout';
import { AddRounded, ArrowBackIosRounded } from '@material-ui/icons';
import AddStockInStorage from './AddStockInStorage';

class BlockInventoryDetails extends Component {
    state = { 
        addForm: false,
        inventory:[],
    }
    
    componentDidMount = async () => {
        // TODO Fetch block inventory
        let req = await fetch("/stocks/locals/block/inventory",{
            method:"POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({blockID: this.props.block.id}),
            credentials: 'same-origin',
        })
        let res = await req.json()

        console.log("get local block inventory", {res});
        if (res) {
            if(res.error){
                console.log("get local block inventory", res.error.error);
            } else {
                this.setState({
                    inventory: res
                })    
            }
        }
    }
    openAddInStorage = (open = true) => {
        this.setState({
            addForm : open,
        })
    }
    render() {
        const {PRODUCTS} = this.props;
        console.log('====================================');
        console.log(this.props);
        console.log('====================================');
        return (
            // <PopUp
            //     title={`Inventaire ${name}`}
            //     maxWidth="md"
            //     close={ this.props.handleClose}
            //     appbar
            // >
                    <Box>
                        {this.state.addForm &&
                            <AddStockInStorage
                                pItem={this.props.pItem}
                                productName={this.props.productName}
                                block={this.props.block}
                                handleClose={()=>this.openAddInStorage(false)}
                            />
                        }
                            <Box >
                                <Box p={1}>
                                    <IconButton
                                        onClick={ this.props.handleClose}
                                    >
                                        <ArrowBackIosRounded />
                                    </IconButton>
                                </Box>
                                <Box p={1} style={{textAlign: "right"}}>
                                    <Fab
                                        onClick={this.openAddInStorage}
                                        color="primary"
                                        size="small"
                                    >
                                        <AddRounded />
                                    </Fab>
                                </Box>
                                
                                <TableLayout className="table-striped">
                                    <TableHead>
                                            <TableRow>
                                                <TableCell >Date d'ajout</TableCell>
                                                <TableCell >Date d'achat</TableCell>
                                                <TableCell >Produit</TableCell>
                                                <TableCell >RFID</TableCell>
                                                <TableCell >Quantité</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.inventory.map( line => (
                                                <TableRow>
                                                    <TableCell>{new Date(line.storage_date).toLocaleDateString()}</TableCell>
                                                    <TableCell>{new Date(line.creation_date).toLocaleDateString()}</TableCell>
                                                    <TableCell>{line.name} | {line.marque} </TableCell>
                                                    <TableCell>{line.RFID}</TableCell>
                                                    <TableCell>{line.quantity}</TableCell>
                                                </TableRow>
                                            ))}
                                            {/* <TableRow>
                                                <TableCell>12/09/2023</TableCell>
                                                <TableCell>Produit 5</TableCell>
                                                <TableCell>7</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>19/09/2023</TableCell>
                                                <TableCell>Produit FGT</TableCell>
                                                <TableCell>4</TableCell>
                                            </TableRow> */}
                                        </TableBody>
                                </TableLayout>
                            </Box>
                        
                    </Box>
            // </PopUp>
                   
        );
    }
}

export default BlockInventoryDetails;